import { createContext } from "react";

import {
  AudioTestState,
  DeviceTesterTestState,
  ResultsViewState,
  DeviceStatusDialogState,
} from "../../types/Device.types";
import { DeviceStatus } from "../results/results-view/ResultsView.types";

import { IDeviceState, IDeviceDispatch } from "./useDeviceTester";
/**
 * React context variable to store state of currently active device settings.
 */
export const DeviceTesterStateContext = createContext<IDeviceState>({
  deviceTesterState: {
    isInfoFetched: false,

    // If we successfully fetched ACS token
    isAcsTokenFetched: false,

    // Track state of device Tester testing flow
    deviceTesterTestState: DeviceTesterTestState.RESULTS,
    audioTestState: AudioTestState.INITIATED,
    resultsViewState: ResultsViewState.INITIAL,
    deviceStatusDialogState: DeviceStatusDialogState.CLOSED,

    // Device test results
    microphoneResult: { status: DeviceStatus.UNTESTED },
    speakerResult: { status: DeviceStatus.UNTESTED },
    cameraResult: { status: DeviceStatus.UNTESTED },
    networkResult: { status: DeviceStatus.UNTESTED },

    deviceSettings: {
      selectedCamera: undefined,
      selectedMicrophone: undefined,
      selectedSpeaker: undefined,

      // Available devices
      microphones: undefined,
      speakers: undefined,
      cameras: undefined,
      isCamOn: false,

      //Audio Video Access Permissions
      cameraAccess: false,
      micAccess: false,
    },
  },
  setVideoStreamingOnOff: async () => undefined,
  startAudioTest: async () => undefined,
  setDeviceDetails: async () => undefined,
  setNetworkConnectionListener: () => ({}),
  checkBrowserSupported: () => ({}),
});

export const DeviceTesterDispatchContext = createContext<IDeviceDispatch>({
  deviceTesterDispatch: () => ({}),
});
